export default __webpack_public_path__ + "static/media/camera-white.d70fbb31.svg";